import { render, staticRenderFns } from "./OrderItemViewer.vue?vue&type=template&id=382b9400"
import script from "./OrderItemViewer.vue?vue&type=script&lang=ts"
export * from "./OrderItemViewer.vue?vue&type=script&lang=ts"
import style0 from "./OrderItemViewer.vue?vue&type=style&index=0&id=382b9400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports